@switch (columnType()) {
  @case (TableColumnType.Ordinal) {}

  @case (TableColumnType.Select) {
    <app-table-header-current-page-row-selection-checkbox />
    <!--    <app-table-header-row-selection-checkbox />-->
  }

  @default {
    @if (shouldShowFilter()) {
      @if (filterKey(); as filterKey) {
        <app-table-filter
          (changes)="handleFilterChanges($event)"
          [filter]="filter()!"
          [key]="filterKey!" />
      } @else {
        <span>Brak definicji klucza filtru.</span>
      }
    } @else {
      <span>-</span>
    }
  }
}
